/* PARENTS AND CHILDRENS */
export const SET_PARENT_INFO = "SET_PARENT_INFO";
export const SET_PARENT_TAX_INFO = "SET_PARENT_TAX_INFO";
export const SET_EQUAL_TIME_PARENTS = "SET_EQUAL_TIME_PARENTS";
export const SET_CHILDRENS_COUNT = "SET_CHILDRENS_COUNT";
export const SET_CHILDREN_INFO = "SET_CHILDREN_INFO";
export const SET_IS_FORM_OPEN = "SET_IS_FORM_OPEN";
export const SET_UPDATE_SECTION = "SET_UPDATE_SECTION";


